import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import Board from "components/Meta/Board";
import Screen from "components/Meta/Screen";
import HeaderPanel from "components/Panel/HeaderPanel";
import PanelRight from "components/Panel/PanelRight";
import { classNames } from "tools/ui";
import saleOrder from "./ModelSale";
import proxy from "api/proxy";
import DashBoardSeller from "./Components/DashBoardSeller";
import useMainStore from "store/mainStore";
import { getStorage, setStorage } from "store/local";

const SaleOrder = ({ config }) => {
  const [showPanelRight, setShowPanelRight] = useState(false);
  const { record } = useMainStore();

  const { data: configData } = useQuery({
    queryKey: ["full_config", config?.id],
    enabled: !!config?.id,
    queryFn: async () => {
      const session = getStorage("ctxSession");
      const { data: userData } = await proxy.search(
        "res.user",
        [["id", "=", session.user]],
        ["rec_name", "name", "shops", "sale_device.name", "sale_device.code"],
      );

      const [modulesRes, configRes, agentRes] = await Promise.all([
        proxy.search(
          "ir.module",
          [
            ["name", "in", ["sale_discount_flex", "sale_packing_unit"]],
            ["state", "=", "activated"],
          ],
          ["name"],
        ),
        proxy.search(
          "dash.app",
          [["id", "=", config.id]],
          ["origin.allow_discount", "origin.allow_manual_pricing"],
        ),
        (async () => {
          let agent = session.agent;
          if (!agent) {
            const { data: agents } = await proxy.search(
              "commission.agent",
              [["user", "=", session.user]],
              ["rec_name", "user.warehouse"],
            );
            if (agents?.length) {
              agent = agents[0];
              const session_ = { ...session, agent };
              setStorage("ctxSession", session_);
            }
          }
          return agent;
        })(),
      ]);
      const configApp = configRes.data ? configRes.data[0]["origin."] : {};
      return {
        ...config,
        ...configApp,
        modules_activated: modulesRes.data?.map((item) => item.name),
        agent: agentRes,
      };
    },
  });

  const ctxView = saleOrder.ctxView(configData ?? {});
  function handleDisplay() {
    setShowPanelRight(!showPanelRight);
  }

  let _displayStyle = "";
  if (showPanelRight) {
    _displayStyle =
      "bg-gray-300 px-2 custom-transition duration-500 sticky w-full";
  }

  const _style = showPanelRight ? "justify-between" : "";

  const dataInfo = {};

  return (
    <Screen>
      <div className={classNames("flex w-full", _style)}>
        {!showPanelRight && <Board ctxView={ctxView} />}
         {!record.id && (
          <PanelRight
            title="Indicador Mes Actual"
            status={showPanelRight}
            handleDisplay={handleDisplay}
            displayOpen={showPanelRight}
            style={_displayStyle}
          >
            <HeaderPanel
              title="sale.sale.panel.status_info"
              dataInfo={dataInfo}
              name="status_info"
            />
            <DashBoardSeller agent={configData?.agent} />
          </PanelRight>
        )}
      </div>
    </Screen>
  );
};

export default SaleOrder;
